export const setServedIds = (state, servedIds = []) => {
  return { servedIds };
};
